import React, { useContext, useMemo } from 'react';
import useExchangeLimits from '../hooks/use-exchange-limits.js';
const initialValue = {
    value: null,
    loading: true,
};
export const LimitsContext = React.createContext(initialValue);
export const useLimitsContext = () => useContext(LimitsContext);
export const LimitsProvider = ({ children }) => {
    const [value, loading] = useExchangeLimits();
    const contextValue = useMemo(() => ({ value, loading }), [loading, value]);
    return React.createElement(LimitsContext.Provider, { value: contextValue }, children);
};
